import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"max-height":"45vh","overflow-y":"auto","overflow-x":"hidden"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createElementVNode("h4", null, "Facture", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.chrono.invoiceChrono,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chrono.invoiceChrono) = $event)),
                label: "Chrono des factures",
                error: _ctx.isInvoiceChronoError,
                "error-messages": _ctx.invoiceChronoError,
                "hide-details": "auto",
                outlined: "",
                readonly: _ctx.isInvoiceDisabled,
                density: "compact"
              }, null, 8, ["modelValue", "error", "error-messages", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            class: "pl-6"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Exemple: " + _toDisplayString(_ctx.invoiceChronoExample), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_select_filled, {
                label: "Rêgle de réinitialisation du compteur des factures",
                modelValue: _ctx.chrono.invoiceResetCounterCondition,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.chrono.invoiceResetCounterCondition) = $event)),
                items: _ctx.resetCounterConditions,
                "item-value": "value",
                "hide-details": "",
                outlined: "",
                readonly: _ctx.isInvoiceDisabled,
                density: "compact",
                "item-title": (item) => item.title
              }, null, 8, ["modelValue", "items", "readonly", "item-title"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createElementVNode("h4", null, "Devis", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.chrono.quoteChrono,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chrono.quoteChrono) = $event)),
                label: "Chrono des devis",
                error: _ctx.isQuoteChronoError,
                "error-messages": _ctx.quoteChronoError,
                "hide-details": "auto",
                outlined: "",
                readonly: _ctx.isQuoteDisabled,
                density: "compact"
              }, null, 8, ["modelValue", "error", "error-messages", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            class: "pl-6"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Exemple: " + _toDisplayString(_ctx.quoteChronoExample), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_select_filled, {
                label: "Rêgle de réinitialisation du compteur des devis",
                modelValue: _ctx.chrono.quoteResetCounterCondition,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.chrono.quoteResetCounterCondition) = $event)),
                items: _ctx.resetCounterConditions,
                "item-value": "value",
                "hide-details": "",
                outlined: "",
                readonly: _ctx.isQuoteDisabled,
                density: "compact",
                "item-title": (item) => item.title
              }, null, 8, ["modelValue", "items", "readonly", "item-title"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createElementVNode("h4", null, "Bon de livraison", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.chrono.deliveryBillChrono,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.chrono.deliveryBillChrono) = $event)),
                label: "Chrono des bon de livraison",
                error: _ctx.isDeliveryBillChronoError,
                "error-messages": _ctx.deliveryBillChronoError,
                "hide-details": "auto",
                outlined: "",
                readonly: _ctx.isDeliveryBillDisabled,
                density: "compact"
              }, null, 8, ["modelValue", "error", "error-messages", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            class: "pl-6"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Exemple: " + _toDisplayString(_ctx.deliveryBillChronoExample), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_select_filled, {
                label: "Rêgle de réinitialisation du compteur des bon de livraisons",
                modelValue: _ctx.chrono.deliveryBillResetCounterCondition,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.chrono.deliveryBillResetCounterCondition) = $event)),
                items: _ctx.resetCounterConditions,
                "item-value": "value",
                "hide-details": "",
                outlined: "",
                readonly: _ctx.isDeliveryBillDisabled,
                density: "compact",
                "item-title": (item) => item.title
              }, null, 8, ["modelValue", "items", "readonly", "item-title"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createElementVNode("h4", null, "Avoir", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.chrono.creditNoteChrono,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.chrono.creditNoteChrono) = $event)),
                label: "Chrono des avoirs",
                error: _ctx.isCreditNoteChronoError,
                "error-messages": _ctx.creditNoteChronoError,
                "hide-details": "auto",
                outlined: "",
                readonly: _ctx.isCreditNoteDisabled,
                density: "compact"
              }, null, 8, ["modelValue", "error", "error-messages", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            class: "pl-6"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Exemple: " + _toDisplayString(_ctx.creditNoteChronoExample), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_select_filled, {
                label: "Rêgle de réinitialisation du compteur des avoirs",
                modelValue: _ctx.chrono.creditNoteResetCounterCondition,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.chrono.creditNoteResetCounterCondition) = $event)),
                items: _ctx.resetCounterConditions,
                "item-value": "value",
                "hide-details": "",
                outlined: "",
                readonly: _ctx.isCreditNoteDisabled,
                density: "compact",
                "item-title": (item) => item.title
              }, null, 8, ["modelValue", "items", "readonly", "item-title"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createElementVNode("h4", null, "Acompte", -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.chrono.depositChrono,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.chrono.depositChrono) = $event)),
                label: "Chrono des acomptes",
                error: _ctx.isDepositChronoError,
                "error-messages": _ctx.depositChronoError,
                "hide-details": "auto",
                outlined: "",
                readonly: _ctx.isDepositDisabled,
                density: "compact"
              }, null, 8, ["modelValue", "error", "error-messages", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            class: "pl-6"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Exemple: " + _toDisplayString(_ctx.depositChronoExample), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_select_filled, {
                label: "Rêgle de réinitialisation du compteur des acomptes",
                modelValue: _ctx.chrono.depositResetCounterCondition,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.chrono.depositResetCounterCondition) = $event)),
                items: _ctx.resetCounterConditions,
                "item-value": "value",
                "hide-details": "",
                outlined: "",
                readonly: _ctx.isDepositDisabled,
                density: "compact",
                "item-title": (item) => item.title
              }, null, 8, ["modelValue", "items", "readonly", "item-title"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}